<!-- 暂无 -->
<!-- 大转盘页面 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goChangeData"
                    >新增大转盘</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="user_turntable_count">
                        <Button @click="goCount(row)">{{
                            row.user_turntable_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.status"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeStatus(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goPreview"
                                >预览溯源码</Button
                            >
                            <Button
                                type="warning"
                                ghost
                                @click="goChangeData(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="changeModal" :title="changeTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="180">
                <RadioGroup
                    class="mb24"
                    v-model="radio_group_value"
                    type="button"
                >
                    <Radio class="mr24" label="1">大转盘活动设置</Radio>
                    <Radio label="2">产品关联设置</Radio>
                </RadioGroup>
                <template v-if="radio_group_value == 1">
                    <FormItem label="活动名称：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.title"
                            placeholder="请输入活动名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="活动模板：">
                        <Button
                            class="theme-bc theme-default-color"
                            v-if="formData.mode == 1"
                            @click="goTemplate(formData.mode)"
                            >转盘</Button
                        >
                        <Button
                            class="theme-bc theme-default-color"
                            v-else-if="formData.mode == 2"
                            @click="goTemplate(formData.mode)"
                            >九宫格</Button
                        >
                        <Button
                            class="theme-bc theme-default-color"
                            v-else
                            @click="goTemplate(formData.mode)"
                            >模板选择</Button
                        >
                    </FormItem>
                    <FormItem label="背景图更换：">
                        <div class="form-upload" @click="openModal(1)">
                            <img
                                class="wh100"
                                v-if="formData.show_background"
                                :src="formData.show_background"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="44"
                                color="#AEAEB3"
                            />
                        </div>
                    </FormItem>
                    <FormItem label="添加奖项：">
                        <Button
                            class="theme-bc theme-default-color"
                            @click="addPrize"
                            >点击添加奖项</Button
                        >
                        <div
                            class="prize-div"
                            v-for="(item, index) in formData.prize_item"
                            :key="index"
                        >
                            <div>
                                <div>
                                    奖品名称：<Input
                                        class="w10"
                                        type="text"
                                        v-model="item.name"
                                        placeholder="请输入奖品名称"
                                    ></Input>
                                </div>
                                <div class="mt24">
                                    奖品数量：<Input
                                        class="w10"
                                        type="text"
                                        v-model="item.num"
                                        placeholder="请输入奖品数量"
                                    ></Input>
                                </div>
                            </div>
                            <div>
                                <div>
                                    中奖概率：<Input
                                        class="w10"
                                        type="text"
                                        v-model="item.rate"
                                        placeholder="请输入中奖概率（%）"
                                    ></Input>
                                </div>
                                <div class="mt24">
                                    奖品类型：
                                    <Select
                                        class="w10"
                                        v-model="item.type"
                                        clearable
                                        filterable
                                        placeholder="请选择奖品类型"
                                    >
                                        <Option
                                            v-for="item in typeList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.name }}</Option
                                        >
                                    </Select>
                                </div>
                            </div>
                            <div v-if="item.type == 2">
                                <div>
                                    奖金金额：<Input
                                        class="w10"
                                        type="text"
                                        v-model="item.money"
                                        placeholder="请输入奖金金额"
                                    ></Input>
                                </div>
                                <div class="mt24">
                                    发放类型：
                                    <Select
                                        class="w10"
                                        v-model="item.send_mode"
                                        clearable
                                        filterable
                                        placeholder="请选择发放类型"
                                    >
                                        <Option
                                            v-for="item in sendModeList"
                                            :value="item.id"
                                            :key="item.id"
                                            >{{ item.name }}</Option
                                        >
                                    </Select>
                                </div>
                            </div>
                            <div style="display: flex">
                                <span>奖品图片：</span>
                                <div
                                    class="form-upload wh90"
                                    @click="openModal(2, index)"
                                >
                                    <img
                                        class="wh100"
                                        v-if="item.pic"
                                        :src="item.pic"
                                    />
                                    <Icon
                                        v-else
                                        type="ios-add"
                                        size="44"
                                        color="#AEAEB3"
                                    />
                                </div>
                            </div>
                            <div class="flex-c">
                                <img
                                    class="wh30"
                                    v-if="formData.prize_item.length > 1"
                                    src="@/assets/pictureLibrary/delete.png"
                                    @click="delPrize(index)"
                                />
                            </div>
                        </div>
                    </FormItem>
                    <FormItem label="未中奖名称：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.not_prize_name"
                            placeholder="谢谢参与"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="var(--primary-color) "
                            />
                            <div slot="content">
                                <p>默认未中奖名称为谢谢参与</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="单用户最大中奖数量：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.prize_num"
                            placeholder="请输入单用户最大中奖数量数量"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="var(--primary-color) "
                            />
                            <div slot="content">
                                <p>一个用户总计最多中奖次数</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="每天中奖人数：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.day_num"
                            placeholder="请输入每天中奖人数"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="var(--primary-color) "
                            />
                            <div slot="content">
                                <p>每天多少人可以中奖</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="中奖频率：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.prize_rate"
                            placeholder="请输入中奖频率"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="var(--primary-color) "
                            />
                            <div slot="content">
                                <p>最少相隔多少人才能中奖一次</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="起止时间：">
                        <DatePicker
                            class="w300"
                            :value="formData.start_date"
                            type="date"
                            placeholder="选择开始时间"
                            @on-change="changeStartDate"
                        ></DatePicker>
                        <DatePicker
                            class="w300 ml24"
                            :value="formData.end_date"
                            type="date"
                            placeholder="选择结束时间"
                            @on-change="changeEndDate"
                        ></DatePicker>
                    </FormItem>
                    <FormItem label="是否需要关注公众号：">
                        <Checkbox
                            v-model="formData.is_attention"
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeAttention"
                        ></Checkbox>
                    </FormItem>
                    <FormItem label="规则介绍：">
                        <editor
                            class="w80"
                            :edtor-con="formData.desc"
                            :index="1"
                            @getContent="getEnContent1"
                            @getContentchange="getEnContentchange1"
                        />
                    </FormItem>
                </template>
                <template v-if="radio_group_value == 2">
                    <FormItem label="产品批次：">
                        <Select
                            class="w300"
                            v-model="formData.batch_id"
                            clearable
                            filterable
                            placeholder="请选择产品批次"
                        >
                            <Option
                                v-for="item in batchList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.batch_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="产品名称：">
                        <Select
                            class="w300"
                            v-model="formData.product_id"
                            clearable
                            filterable
                            placeholder="请选择产品名称"
                        >
                            <Option
                                v-for="item in productList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.product_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="产品经销商：">
                        <Select
                            class="w300"
                            v-model="formData.agent_id"
                            clearable
                            filterable
                            placeholder="请选择产品经销商"
                        >
                            <Option
                                v-for="item in agentList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.agent_name }}</Option
                            >
                        </Select>
                    </FormItem>
                </template>
                <div class="footer">
                    <Button @click="cancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="submitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <!-- 预览溯源码 -->
        <Modal
            v-model="previewModal"
            title="预览"
            width="30"
            :mask-closable="false"
        >
            <div>
                <VueQr
                    class="wh100"
                    id="vueQr"
                    :text="itemData.qrcode"
                ></VueQr>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 模板选择 -->
        <Modal
            v-model="templateModal"
            title="模板选择"
            width="50"
            :mask-closable="false"
        >
            <div class="flex-sb">
                <div class="w45 ta-c">
                    <img
                        class="wh100"
                        src="@/assets/turntable.png"
                    />
                    <Button
                        :class="{ btnActive: isActive1 }"
                        @click="toggleActive1"
                        >{{ isActive1 ? "已选择" : "选择" }}</Button
                    >
                </div>
                <div class="w45 ta-c">
                    <img
                        class="wh100"
                        src="@/assets/nine-square.png"
                    />
                    <Button
                        :class="{ btnActive: isActive2 }"
                        @click="toggleActive2"
                        >{{ isActive2 ? "已选择" : "选择" }}</Button
                    >
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 参与人数 -->
        <Drawer v-model="countDrawer" title="参与人数" width="80">
            <div>
                <div class="flex-sb mb24">
                    <div>
                        <Select
                            class="w200 mr24"
                            v-model="pageCount.prize_status"
                            clearable
                            filterable
                            placeholder="请选择领取状态"
                        >
                            <Option
                                v-for="item in prizeStatusList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                        <Select
                            class="w200 mr24"
                            v-model="pageCount.pay_status"
                            clearable
                            filterable
                            placeholder="请选择支付状态"
                        >
                            <Option
                                v-for="item in payStatusList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                        <Select
                            class="w200 mr24"
                            v-model="pageCount.is_contact"
                            clearable
                            filterable
                            placeholder="请选择联系状态"
                        >
                            <Option
                                v-for="item in contactList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </div>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="ios-search"
                        @click="goSearch"
                        >确认搜索</Button
                    >
                </div>
                <Table :columns="columnCount" :data="dataCount" border>
                    <template slot-scope="{ row }" slot="type">
                        <div v-if="row.prize.type == 1">线下奖品</div>
                        <div v-if="row.prize.type == 2">线上奖金</div>
                    </template>
                    <template slot-scope="{ row }" slot="prize">
                        <div>{{ row.prize.name }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="prize_status">
                        <div v-if="row.prize_status == 0">未领取</div>
                        <div v-if="row.prize_status == 1">已领取</div>
                    </template>
                    <template slot-scope="{ row }" slot="pay_status">
                        <div v-if="row.pay_status == 0">付款中</div>
                        <div v-if="row.pay_status == 1">成功</div>
                        <div v-if="row.pay_status == 2">失败</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                v-if="row.is_contact == 0"
                                type="warning"
                                ghost
                                @click="goContract(row)"
                                >联系</Button
                            >
                            <Button
                                v-if="row.prize_status == 0"
                                type="warning"
                                ghost
                                @click="goExamine(row)"
                                >审核</Button
                            >
                            <Button
                                v-if="row.pay_status == 2"
                                type="warning"
                                ghost
                                @click="goRefresh(row)"
                                >重新发放</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageCount.page"
                        :page-size="pageCount.limit"
                        :total="totalCount"
                        show-elevator
                        show-total
                        @on-change="pageChangeCount"
                    />
                </div>
            </div>
        </Drawer>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    assembly_turntable_list,
    assembly_turntable_save,
    assembly_turntable_delete,
    assembly_turntable_info,
    assembly_turntable_status,
    assembly_turntable_prize,
    assembly_turntable_contract,
    assembly_turntable_examine,
    assembly_turntable_refresh,
    get_options,
} from "@/api/index";
import VueQr from "vue-qr";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { VueQr, pictureLibrary, editor },
    data() {
        return {
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "活动名称", key: "title", align: "center" },
                { title: "开始时间", key: "start_date", align: "center" },
                { title: "结束时间", key: "end_date", align: "center" },
                {
                    title: "参与人数",
                    slot: "user_turntable_count",
                    align: "center",
                },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            changeModal: false,
            changeTitle: "",
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                mode: "",
                title: "",
                background_url: "",
                start_date: "",
                end_date: "",
                prize_num: "",
                day_num: "",
                prize_rate: "",
                desc: "",
                is_attention: 0,
                not_prize_name: "",
                id: "",
                prize_item: [
                    {
                        name: "",
                        type: "",
                        pic: "",
                        rate: "",
                        num: "",
                        money: "",
                        send_mode: "",
                    },
                ],
                show_background: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            typeList: [
                { id: 1, name: "线下奖品" },
                { id: 2, name: "线上奖金" },
            ],
            sendModeList: [
                { id: 1, name: "直接发放" },
                { id: 2, name: "审核后发放" },
            ],
            previewModal: false,
            itemData: {
                qrcode: "",
            },
            templateModal: false,
            isActive1: false,
            isActive2: false,
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                turntable_id: "",
                prize_status: -1,
                pay_status: -1,
                is_contact: -1,
            },
            totalCount: 0,
            columnCount: [
                { type: "index", width: 60, align: "center" },
                { title: "发放类型", slot: "type", align: "center" },
                { title: "奖金/奖品", slot: "prize", align: "center" },
                { title: "兑换码", key: "exchange_code", align: "center" },
                { title: "领取时间", key: "created_at", align: "center" },
                { title: "领取状态", slot: "prize_status", align: "center" },
                { title: "付款状态", slot: "pay_status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataCount: [],
            prizeStatusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "未兑换(未审核)" },
                { id: 1, name: "已兑换" },
            ],
            payStatusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "付款中" },
                { id: 1, name: "成功" },
                { id: 2, name: "失败" },
            ],
            contactList: [
                { id: -1, name: "全部" },
                { id: 0, name: "未联系" },
                { id: 1, name: "已联系" },
            ],
            radio_group_value: "1",
        };
    },
    mounted() {
        this.getList();
        this.getOptions();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_background = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.background_url = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param2.length; i++) {
                    this.formData.prize_item[this.srctype].pic = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.switch_modal = true;
            this.srctype = index;
        },
        getList() {
            assembly_turntable_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeCount(index) {
            this.pageCount.page = index;
            this.getAssemblyTurntablePrize();
        },
        // 大转盘中奖记录
        getAssemblyTurntablePrize() {
            assembly_turntable_prize(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goSearch() {
            this.pageCount.page = 1;
            this.getAssemblyTurntablePrize();
        },
        // 详情
        getAssemblyTurntableInfo() {
            assembly_turntable_info({ id: this.formData.id })
                .then((res) => {
                    this.formData.batch_id = res.data.batch_id;
                    this.formData.product_id = res.data.product_id;
                    this.formData.agent_id = res.data.agent_id;
                    this.formData.mode = res.data.mode;
                    this.formData.title = res.data.title;
                    this.formData.background_url = res.data.background_url;
                    this.formData.start_date = res.data.start_date;
                    this.formData.end_date = res.data.end_date;
                    this.formData.prize_num = res.data.prize_num;
                    this.formData.day_num = res.data.day_num;
                    this.formData.prize_rate = res.data.prize_rate;
                    this.formData.desc = res.data.desc;
                    this.formData.is_attention = res.data.is_attention;
                    this.formData.not_prize_name = res.data.not_prize_name;
                    this.formData.show_background = res.data.show_background;
                    // 数组重构
                    var prize = res.data.prize;
                    prize = prize.map((item) => ({
                        name: item.name,
                        type: item.type,
                        pic: item.pic,
                        rate: item.rate,
                        num: item.num,
                        money: item.money,
                        send_mode: item.send_mode,
                    }));
                    this.formData.prize_item = prize;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 下拉
        getOptions() {
            get_options()
                .then((res) => {
                    this.productList = res.data.product;
                    this.agentList = res.data.agent;
                    this.batchList = res.data.batch;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        addPrize() {
            this.formData.prize_item.push({
                name: "",
                type: "",
                pic: "",
                rate: "",
                num: "",
                money: "",
                send_mode: "",
            });
        },
        delPrize(i) {
            this.$delete(this.formData.prize_item, i);
        },
        // Drawer
        goChangeData(row) {
            if (row.id) {
                this.changeTitle = "编辑大转盘活动";
                this.formData.id = row.id;
                this.getAssemblyTurntableInfo();
            } else {
                this.changeTitle = "新增大转盘活动";
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.mode = "";
                this.formData.title = "";
                this.formData.background_url = "";
                this.formData.start_date = "";
                this.formData.end_date = "";
                this.formData.prize_num = "";
                this.formData.day_num = "";
                this.formData.prize_rate = "";
                this.formData.desc = "";
                this.formData.is_attention = 0;
                this.formData.not_prize_name = "";
                this.formData.id = "";
                this.formData.prize_item = [
                    {
                        name: "",
                        type: "",
                        pic: "",
                        rate: "",
                        num: "",
                        money: "",
                        send_mode: "",
                    },
                ];
                this.formData.show_background = "";
            }
            this.changeModal = true;
        },
        cancelForm() {
            this.changeModal = false;
        },
        // 确定（提交表单）
        submitForm() {
            if (!this.formData.not_prize_name) {
                this.formData.not_prize_name = "谢谢参与";
            }
            assembly_turntable_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.changeModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    assembly_turntable_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goPreview() {
            this.previewModal = true;
            this.itemData.qrcode = "";
        },
        //富文本
        getEnContentchange1(detailData) {
            this.formData.desc = detailData.editorData;
        },
        getEnContent1(detailData) {
            this.formData.desc = detailData.editorData;
        },
        goTemplate(row) {
            if (row) {
                this.formData.mode = row;
                if (this.formData.mode == 1) {
                    this.isActive1 = true;
                    this.isActive2 = false;
                }
                if (this.formData.mode == 2) {
                    this.isActive2 = true;
                    this.isActive1 = false;
                }
            } else {
                this.formData.mode = "";
            }
            this.templateModal = true;
        },
        toggleActive1() {
            this.isActive1 = !this.isActive1;
            if (this.isActive1) {
                this.isActive2 = false;
                this.formData.mode = 1;
            }
        },
        toggleActive2() {
            this.isActive2 = !this.isActive2;
            if (this.isActive2) {
                this.isActive1 = false;
                this.formData.mode = 2;
            }
        },
        changeStartDate(e) {
            if (e) {
                this.formData.start_date = e;
            } else {
                this.formData.start_date = "";
            }
        },
        changeEndDate(e) {
            if (e) {
                this.formData.end_date = e;
            } else {
                this.formData.end_date = "";
            }
        },
        changeAttention(e) {
            if (e) {
                this.formData.is_attention = 1;
            } else {
                this.formData.is_attention = 0;
            }
        },
        changeStatus(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    let data = {
                        id: row.id,
                    };
                    assembly_turntable_status(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        goCount(row) {
            this.pageCount.turntable_id = row.id;
            this.getAssemblyTurntablePrize();
            this.countDrawer = true;
        },
        goContract(row) {
            assembly_turntable_contract({ id: row.id })
                .then((res) => {
                    this.getAssemblyTurntablePrize();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goExamine(row) {
            assembly_turntable_examine({ id: row.id })
                .then((res) => {
                    this.getAssemblyTurntablePrize();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goRefresh(row) {
            assembly_turntable_refresh({ id: row.id })
                .then((res) => {
                    this.getAssemblyTurntablePrize();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.form-upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btnActive {
    background-color: var(--primary-color);
    border: 1px solid var(--primary-color);
    color: #fff;
}
.btnActive {
    background-color: var(--primary-color);
    border: 1px solid var(--primary-color);
    color: #fff;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.prize-div {
    margin: 12px 0 0 0;
    padding: 12px;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    display: flex;
    justify-content: space-between;
}
.w10 {
    width: 10vw;
}
.wh90 {
    height: 90px;
    width: 90px;
}
.wh30 {
    width: 30px;
    height: 30px;
}
.w80 {
    width: 80%;
}
.w45 {
    width: 45%;
}
.ta-c {
    text-align: center;
}
.cursor-p {
    cursor: pointer;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>